import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaChevronRight } from 'react-icons/fa';

import { filAriane } from './navigation';

/**
 * Le fil d'Ariane de la coquille du gestionnaire (Yros/Kavero#416) : où l'on
 * est dans la carte de navigation, et un chemin pour remonter.
 */
const FilAriane = ({ user }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const miettes = filAriane(location, user, t);

  if (miettes.length === 0) return null;

  return (
    <nav aria-label={t('filAriane.titre')}>
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-gray-600">
        {miettes.map((miette, index) => (
          <li key={`${index}-${miette.libelle}`} className="flex items-center gap-2">
            {index > 0 && <FaChevronRight aria-hidden="true" className="h-3 w-3 text-gray-400" />}
            {miette.courante ? (
              <span aria-current="page" className="font-medium text-gray-800">{miette.libelle}</span>
            ) : miette.chemin ? (
              <Link
                to={miette.chemin}
                className="rounded hover:text-[--color-primary] hover:underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-[--color-primary]"
              >
                {miette.libelle}
              </Link>
            ) : (
              <span>{miette.libelle}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default FilAriane;
